import moment from "moment";
import { forgivedDifferenceTimeManagement } from "./constants";

export function expiration(date, time) {
  if (date && time) {
    let datetime = `${date} ${time}`;
    datetime = moment(datetime, "YYYY-MM-DD HH:mm:ss").format(
      "YYYY-MM-DD HH:mm"
    );
    let now = moment().format("YYYY-MM-DD HH:mm");
    if (datetime <= now) return true;
  }
  return false;
}

export function calcVolPerValve(valve, duration, flows) {
  if (duration) {
    let sum = 0;

    if(valve.MIN_FLOW && valve.MAX_FLOW) {
      sum = valve.MIN_FLOW + valve.MAX_FLOW;
    }

    let flow = flows[valve.ID] || sum / 2;
    let time = duration;
    let hours = time / 60;
    return (hours * flow).toFixed(2);

  }
  return "?";
}

export function avgVolume(group, flows) {
  if (group.ELEMENTS.length) {
    let flag = false; //para indicar que há parcelas deconhecidas (aka válvulas sem VAZÃO MIN e MÁX cadastradas)
    let duration = group.duration.TIME;
    let volumes = group.ELEMENTS.map((e) => {
      let volPerValve = calcVolPerValve(e, duration, flows);
      if (volPerValve != "?") return parseFloat(volPerValve);
      else {
        if (!flag) flag = true;
        return 0;
      }
    });
    let total = volumes.reduce((acc, e) => acc + e);
    return total.toFixed(2);
  }
  return "?";
}

export function getManagementClassificationSchedule(diffMins) {
  if(diffMins < (-1 * forgivedDifferenceTimeManagement)) {
    return 'low-water';

  } else if(diffMins > forgivedDifferenceTimeManagement) {
    return 'extra-water';

  } else {
    return 'good-water';
    
  }
}

export function getValvesTotalDurationByLevels(levelsMap) {
  const valvesAndTotalVolumesCurrent = {};
  
  levelsMap
    .map(level => ({
      NAME: level.ELEMENTS[0].NAME,
      DURATION_TIME: Number(level.duration.TIME)
    }))
    .forEach(valveLevel => {
      if(valvesAndTotalVolumesCurrent[valveLevel.NAME]) {
        valvesAndTotalVolumesCurrent[valveLevel.NAME] += valveLevel.DURATION_TIME;
        
      } else {
        valvesAndTotalVolumesCurrent[valveLevel.NAME] = valveLevel.DURATION_TIME;
        
      }
    });

    return valvesAndTotalVolumesCurrent;
}